import React, { useEffect, useState } from "react";
import { retornaCpo, setMemoria } from "./auxiliar";
import { Modal, Container, Row, Col, Button, Alert } from "react-bootstrap";
import api from "../services/api";

export default function Identifica( props ) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [tipoMensagem, setTipoMensagem] = useState("danger");
  const [pessoa, setPessoa] = useState([]);
  const [chave, setChave] = useState("");

  useEffect(() => {
    async function loadPessoa() {
      if (email.indexOf("@") > 1) {
        const response = await api.get(`/api/pessoa/${email}/publico`);
        setPessoa(response.data[0]);
      }
    }
    loadPessoa();
  }, [email]);

  useEffect(() => {
    async function loadChave() {
      const sistema = '***consulta_publica***';
      const response = await api.get('/api/configuracao', {
        headers: { sistema }
      });
      setChave(response.data[0].NO_EMAIL);
    }
    loadChave();
  }, [email]);

  function handleEnviar(){
    setMemoria("","",false);
    setTipoMensagem("danger");
    setMensagem("");

    if (email.length < 4 || senha.length < 4 || !pessoa ){
      setMensagem("Identificação invalida!");
    } else {
      const senhaTratada = retornaCpo(pessoa.DS_SENHA, chave);
      if (senha !== senhaTratada){
        setMensagem("Identificação Inválida!");
      } else {
        localStorage.setItem("Login","Sistema");
        setMemoria(pessoa.NO_PESSOA,email, true);
        props.onHide();
        window.location.href= "/";
      }
    }
  }
  function handleSair(){
    setMemoria("","", false);
    props.onHide();
  }

  function handleNovo() {
    window.location.href=`/Consulta/0/NovoParticipante`;
  }

  function handleSenha() {

    window.location.href=`/Consulta/0/EsqueciSenha`;
  }

  return (
    <>
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter" size="lg" animation={true}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Identificação do Participante
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
          <form id="formPart">
              <Row className="show-grid">
                <Col sm={2}>
                    <label htmlFor="email">E-mail:</label>
                </Col>
                <Col sm={10}>
                    <input
                        type="email"
                        id="email"
                        className="Requerido"
                        placeholder="Informe e-mail"
                        email={email}
                        onChange={event => setEmail(event.target.value)}
                    />
                </Col>
              </Row>
              <Row className="show-grid">
                <Col sm={2}>
                    <label htmlFor="senha">Senha:</label>
                </Col>
                <Col sm={10}>
                    <input
                        type="password"
                        id="senha"
                        className="Requerido"
                        placeholder="Informe sua senha"
                        value={senha}
                        onChange={event =>setSenha(event.target.value)}
                        autoComplete="password"
                    />
                </Col>
              </Row>
              <Row className={mensagem ? "mostrar" : "naoMostrar"}>
                  <Col sm="12">
                    <Alert variant={tipoMensagem}>
                        {mensagem}
                    </Alert>
                  </Col>
                </Row>
              <Row>
                <Col sm="12" className="observacao">
                  - Caso ainda não tenha se inscrito como Participante escolha "Novo participante".<br />
                  - Caso não se lembre de sua senha, utilize "Esqueci minha senha".
                </Col>
              </Row>
            </form>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleSair}>Sair</Button>
          <Button variant="secondary" onClick={props.onHide}>Cancelar</Button>
          {/* <Button variant="info" onClick={handleSenha}>Esqueci minha senha</Button>
          <Button variant="primary" onClick={handleNovo}>Novo Participante</Button> */}
          <Button variant="success" onClick={handleEnviar}>Enviar</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}